import "./css/forgetpassword.css"
import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"

const ForgetPassword = () => {
    const navigate = useNavigate()
    
    useEffect(() => {
        if (
            localStorage.getItem("name") !== null
            && localStorage.getItem("email") !== null
            && localStorage.getItem("status") !== null
            && localStorage.getItem("token") !== null
            && localStorage.getItem("user_id") !== null
        ) {
            navigate("/profile")
        }

        if (
            localStorage.getItem("name") === null
            || localStorage.getItem("email") === null
            || localStorage.getItem("status") === null
            || localStorage.getItem("token") === null
            || localStorage.getItem("user_id") === null
        ) {
            localStorage.clear();
        }
    })
    
    const [closeErrorMessage, setCloseErrorMessage] = useState(true)
    //const [errorMessage, setErrorMessage] = useState()
    const errorMessage = "wait for new code"
    const [mail, setMail] = useState("")

    return (
        <div className="authPageWrapper">
            <div className="authMainContainer">
                
                {/* Image Section - CSS के द्वारा हैंडल किया जाएगा */}
                <div className="authImageSection forgetPwdImageBg"></div>

                <div className="authFormSection">
                    <div className="authFormHeader">
                        <h2>Forget Password</h2>
                        <p>Enter your registered email address to receive a password reset link.</p>
                    </div>

                    <div className="authForm">
                        <div className="inputGroup">
                            <label htmlFor="registered">Registered E-mail</label>
                            <div className="inputWrapper">
                                <i className="fa-solid fa-envelope inputIcon"></i>
                                <input type="email"
                                    id="registered"
                                    name="userregistered"
                                    placeholder="mail@example.com"
                                    value={mail}
                                    onChange={(e) => setMail(e.target.value)} 
                                />
                            </div>
                        </div>

                        <button className="submitBtn">Submit</button>
                    </div>
                </div>
            </div>

            {/* Error Modal */}
            {!closeErrorMessage && (
                <div className="authModalOverlay">
                    <div className="authModalBox">
                        <i className="fa-solid fa-circle-exclamation errorIcon"></i>
                        <p className="modalMessage">{errorMessage}</p>
                        <button className="modalBtn" onClick={() => setCloseErrorMessage(true)}>Ok</button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ForgetPassword